/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".upload-files[_ngcontent-%COMP%]{margin:1rem auto}  .clr-control-container textarea{width:100%;height:8rem}  .clr-control-container input{width:100%}"];
export { styles as styles };

